import { Box, Flex } from "@chakra-ui/react";
import { FormRow, NumberInput } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { can } from "@src/utils/components/permissions";
import { fieldNumberModelToInputProps } from "@src/utils/forms/inputHelpers";
import { minValue } from "@src/utils/forms/validators";
import { useStore } from "@src/utils/hooks";
import { NumberModel } from "@src/utils/models";
import { FieldState } from "formstate";
import { debounce } from "lodash";
import { observer, useLocalObservable } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, useEffect } from "react";
import type { TimeTrackingRateModel } from "./models";

export const TimeTrackingRate: FunctionComponent<
  React.PropsWithChildren<{
    rate: TimeTrackingRateModel;
    onRateChange(id: string, val: NumberModel): void;
    disabled?: boolean;
  }>
> = observer(function TimeTrackingRate({ rate, onRateChange, disabled }) {
  const { workspaceStore } = useStore();

  const state = useLocalObservable(() => ({
    rate: new FieldState(NumberModel.fromDenomValue(rate.rate, 2)).validators(
      minValue(0),
    ),
    onRateChange: debounce(() => {
      onRateChange(rate.timeTrackingWorkType.id, state.rate.$);
    }, 1000),
  }));

  useEffect(() => {
    state.rate.onDidChange(() => {
      state.onRateChange();
    });
  }, []);

  return (
    <Box mb="6">
      <FormRow title={<span>{rate.timeTrackingWorkType.title}</span>}>
        <Flex align="center">
          <div style={{ maxWidth: "150px" }}>
            <NumberInput
              currency
              id="field-project-settings-average-time-rate"
              suffix={workspaceStore.settings?.currency.code}
              disabled={disabled}
              readOnly={!can("brand_update")}
              {...fieldNumberModelToInputProps(state.rate)}
            />
          </div>
          <span className="ml-5">
            {workspaceStore.settings?.time_tracking_rate_type ===
              "man-hour" && <Trans>per hour</Trans>}

            {workspaceStore.settings?.time_tracking_rate_type === "man-day" && (
              <Trans>per MD</Trans>
            )}
          </span>
        </Flex>
      </FormRow>
    </Box>
  );
});
